import { render, staticRenderFns } from "./StudentPreRegistrationDetail.vue?vue&type=template&id=667566c6&scoped=true"
import script from "./StudentPreRegistrationDetail.vue?vue&type=script&lang=js"
export * from "./StudentPreRegistrationDetail.vue?vue&type=script&lang=js"
import style0 from "./StudentPreRegistrationDetail.vue?vue&type=style&index=0&id=667566c6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667566c6",
  null
  
)

export default component.exports